module.exports = __webpack_public_path__ + "img/graphic.4ab9cb23.svg";